module.exports = __webpack_public_path__ + "static/img/4_6_1.b000947f.jpg";